<template>
  <div>
    <h2 :class="['headline', 'font-grey', 'font-l-600']" v-html="title" />
    <div :class="['server-side-description']" v-html="description" />

    <example-title title="Down-pointing shadows" />
    <vc-layout :spacing="8">
      <vc-col :span="4" v-for="index in 6" :key="index" xs12 sm8 md8>
        <div :class="['elevation-sample', 'align-center']">
          <vc-avatar color="white" :class="[`elevation-${index}`]" size="96" src="/static/images/avatar-01.png" />
          <h3 :class="['body-1', 'font-grey', 'font-l-600']">
            <code>.elevation-{{ index }}</code>
          </h3>
        </div>
      </vc-col>
    </vc-layout>
    <vc-layout :spacing="8">
      <vc-col :span="4" v-for="index in 6" :key="index" xs12 sm8 md8>
        <div :class="['elevation-sample', 'align-center']">
          <vc-avatar color="white" :class="[`elevation-${index + 6}`]" size="96" src="/static/images/avatar-02.png" />
          <h3 :class="['body-1', 'font-grey', 'font-l-600']">
            <code>.elevation-{{ index + 6 }}</code>
          </h3>
        </div>
      </vc-col>
    </vc-layout>
    <vc-layout :spacing="8">
      <vc-col :span="4" v-for="index in 6" :key="index" xs12 sm8 md8>
        <div :class="['elevation-sample', 'align-center']">
          <vc-avatar color="white" :class="[`elevation-${index + 12}`]" size="96" src="/static/images/avatar-03.png" />
          <h3 :class="['body-1', 'font-grey', 'font-l-600']">
            <code>.elevation-{{ index + 12 }}</code>
          </h3>
        </div>
      </vc-col>
    </vc-layout>
    <vc-layout :spacing="8">
      <vc-col :span="4" v-for="index in 6" :key="index" xs12 sm8 md8>
        <div :class="['elevation-sample', 'align-center']">
          <vc-avatar color="white" :class="[`elevation-${index + 18}`]" size="96" src="/static/images/avatar-04.png" />
          <h3 :class="['body-1', 'font-grey', 'font-l-600']">
            <code>.elevation-{{ index + 18 }}</code>
          </h3>
        </div>
      </vc-col>
    </vc-layout>

    <example-title title="Up-pointing shadows" />
    <vc-layout :spacing="8">
      <vc-col :span="4" v-for="index in 6" :key="index" xs12 sm8 md8>
        <div :class="['elevation-sample', 'align-center']">
          <vc-avatar color="white" :class="[`elevation-up-${index}`]" size="96" src="/static/images/avatar-01.png" />
          <h3 :class="['body-1', 'font-grey', 'font-l-600']">
            <code>.elevation-up-{{ index }}</code>
          </h3>
        </div>
      </vc-col>
    </vc-layout>
    <vc-layout :spacing="8">
      <vc-col :span="4" v-for="index in 6" :key="index" xs12 sm8 md8>
        <div :class="['elevation-sample', 'align-center']">
          <vc-avatar color="white" :class="[`elevation-up-${index + 6}`]" size="96" src="/static/images/avatar-02.png" />
          <h3 :class="['body-1', 'font-grey', 'font-l-600']">
            <code>.elevation-up-{{ index + 6 }}</code>
          </h3>
        </div>
      </vc-col>
    </vc-layout>
    <vc-layout :spacing="8">
      <vc-col :span="4" v-for="index in 6" :key="index" xs12 sm8 md8>
        <div :class="['elevation-sample', 'align-center']">
          <vc-avatar color="white" :class="[`elevation-up-${index + 12}`]" size="96" src="/static/images/avatar-03.png" />
          <h3 :class="['body-1', 'font-grey', 'font-l-600']">
            <code>.elevation-up-{{ index + 12 }}</code>
          </h3>
        </div>
      </vc-col>
    </vc-layout>
    <vc-layout :spacing="8">
      <vc-col :span="4" v-for="index in 6" :key="index" xs12 sm8 md8>
        <div :class="['elevation-sample', 'align-center']">
          <vc-avatar color="white" :class="[`elevation-up-${index + 18}`]" size="96" src="/static/images/avatar-04.png" />
          <h3 :class="['body-1', 'font-grey', 'font-l-600']">
            <code>.elevation-up-{{ index + 18 }}</code>
          </h3>
        </div>
      </vc-col>
    </vc-layout>
  </div>
</template>
<script>
import methods from '../helpers/methods'

export default {
  name: 'ElevationPage',
  mixins: [
    methods
  ],
  data () {
    return {
      title: null,
      description: null
    }
  },
  mounted () {
    this.getPage()
  }
}
</script>
<style>
.elevation-sample h4
{
  font-weight: 500;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/pages/elevation.vue